module.exports = __webpack_public_path__ + "img/livre_film.596547d7.jpg";